import { Box, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';
import PropTypes from 'prop-types';

const OpeningHoursDisplay = ({ collectionPoint }) => {
    const translate = useTranslate();

    const formatDayHours = (dayKey, dayName, closed, from, to) => {
        if (closed) {
            return `${dayName}: ${translate('resources.collectionPoint.form.closed')}`;
        }
        return `${dayName}: ${from} - ${to}`;
    };

    const hours = [
        formatDayHours('mon', translate('resources.collectionPoint.days.mon'), collectionPoint.monClosed, collectionPoint.monFrom, collectionPoint.monTo),
        formatDayHours('tue', translate('resources.collectionPoint.days.tue'), collectionPoint.tueClosed, collectionPoint.tueFrom, collectionPoint.tueTo),
        formatDayHours('wed', translate('resources.collectionPoint.days.wed'), collectionPoint.wedClosed, collectionPoint.wedFrom, collectionPoint.wedTo),
        formatDayHours('thu', translate('resources.collectionPoint.days.thu'), collectionPoint.thuClosed, collectionPoint.thuFrom, collectionPoint.thuTo),
        formatDayHours('fri', translate('resources.collectionPoint.days.fri'), collectionPoint.friClosed, collectionPoint.friFrom, collectionPoint.friTo),
        formatDayHours('sat', translate('resources.collectionPoint.days.sat'), collectionPoint.satClosed, collectionPoint.satFrom, collectionPoint.satTo),
        formatDayHours('sun', translate('resources.collectionPoint.days.sun'), collectionPoint.sunClosed, collectionPoint.sunFrom, collectionPoint.sunTo),
    ].join(', ');

    return (
        <Box label={translate('resources.collectionPoint.labels.openingHoursSection')}>
            <Typography variant='caption' className='no-bold'>
                {hours}
            </Typography>
        </Box>
    );
};

OpeningHoursDisplay.propTypes = {
    collectionPoint: PropTypes.shape({
        monClosed: PropTypes.bool,
        monFrom: PropTypes.string,
        monTo: PropTypes.string,
        tueClosed: PropTypes.bool,
        tueFrom: PropTypes.string,
        tueTo: PropTypes.string,
        wedClosed: PropTypes.bool,
        wedFrom: PropTypes.string,
        wedTo: PropTypes.string,
        thuClosed: PropTypes.bool,
        thuFrom: PropTypes.string,
        thuTo: PropTypes.string,
        friClosed: PropTypes.bool,
        friFrom: PropTypes.string,
        friTo: PropTypes.string,
        satClosed: PropTypes.bool,
        satFrom: PropTypes.string,
        satTo: PropTypes.string,
        sunClosed: PropTypes.bool,
        sunFrom: PropTypes.string,
        sunTo: PropTypes.string,
    }).isRequired,
};

export default OpeningHoursDisplay;
